import React from 'react';
import classNames from 'classnames';
import { Link } from '@capintel/component-lib/link';
import { formatMessage } from '../../../utils/i18n';

type Props = {
  className?: string;
  anchor?: string;
};

const SkipContentLink = ({ className, anchor = '#content', ...rest }: Props) => (
  <span className={classNames('skip-content-link', className)} {...rest}>
    <Link href={anchor} icon="arrow-downward">
      <span>{formatMessage('SiteNavigation.SkipToContent')}</span>
    </Link>
  </span>
);

export default SkipContentLink;
